<template>
  <div style='background-color: #ededed'>
    <v-hover v-slot='{ hover }' :value='opened' open-delay='350'>
      <div
        :class="opened || hover ? 'l-sidebar__open' : 'l-sidebar__close'"
        class='d-flex justify-space-between flex-column transition-fast-in-fast-out'
        style='
          height: calc(100vh - 48px);
          background-color: #ededed;
          position: fixed;
          margin-top: 48px;
          z-index: 99;
        '
      >
        <div>
          <SidebarHeader
            :site-name='site.name'
            :site-favicon='site.favicon.url'
            :media-root='mediaRootPath()'
            :opened='opened || hover'
          />
        </div>
        <slot />

        <v-list
          class='mb-1'
          width='100%'
          style='background-color: rgba(0, 0, 0, 0);'
        >
          <SidebarSwitchItem
            :opened='opened'
            @open='opened = true'
            @close='opened = false'
          />
          <v-list-item class='px-3' style='width: 100%'>
            <v-img
              v-show='opened || hover'
              class='mx-auto mt-1 transition-fast-in-fast-out'
              min-width='90'
              max-width='90'
              :src="require('@/assets/b-cms-logo.png')"
            ></v-img>
          </v-list-item>
            <v-list-item style='width: 100%'>
              <span
                v-show='opened || hover'
                class='transition-fast-in-fast-out'
                style="font-size: 12px; color: gray;"
              >
                対応ブラウザはchromeのみです。
              </span>
            </v-list-item>
        </v-list>
      </div>
    </v-hover>
    <div
      :class="opened ? 'l-sidebar__open' : 'l-sidebar__close'"
      style='opacity: 0; height: 100vh'
    ></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SidebarHeader from '/src/components/shared/SidebarLayout/SidebarHeader'
import SidebarSwitchItem from '/src/components/shared/SidebarLayout/SidebarSwitchItem'
import urlUtils from '@/mixins/url_utils'

export default {
  name: 'SidebarLayoutContainer',
  components: { SidebarSwitchItem, SidebarHeader },
  mixins: [urlUtils],
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser,
      site: (state) => state.SiteStore.site
    }),
    ...mapGetters('UserStore', ['judgePermissionBySituations'])
  },
  data () {
    return {
      opened: true
    }
  }
}
</script>

<style scoped lang='sass'>
.l-sidebar
  &__transition
    transition: width .2s, transform .2s

  &__open
    width: 190px
    max-width: 190px

  &__close
    width: 55px
    max-width: 55px
</style>
